/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TerminalState } from './TerminalState';
import {
    TerminalStateFromJSON,
    TerminalStateFromJSONTyped,
    TerminalStateToJSON,
} from './TerminalState';

/**
 * 
 * @export
 * @interface TerminalStatusResponse
 */
export interface TerminalStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof TerminalStatusResponse
     */
    pspTerminalId: string;
    /**
     * 
     * @type {TerminalState}
     * @memberof TerminalStatusResponse
     */
    latestState: TerminalState;
}

/**
 * Check if a given object implements the TerminalStatusResponse interface.
 */
export function instanceOfTerminalStatusResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "pspTerminalId" in value;
    isInstance = isInstance && "latestState" in value;

    return isInstance;
}

export function TerminalStatusResponseFromJSON(json: any): TerminalStatusResponse {
    return TerminalStatusResponseFromJSONTyped(json, false);
}

export function TerminalStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminalStatusResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pspTerminalId': json['pspTerminalId'],
        'latestState': TerminalStateFromJSON(json['latestState']),
    };
}

export function TerminalStatusResponseToJSON(value?: TerminalStatusResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pspTerminalId': value.pspTerminalId,
        'latestState': TerminalStateToJSON(value.latestState),
    };
}

